import { render, staticRenderFns } from "./Measures.vue?vue&type=template&id=7c22c314&scoped=true"
import script from "./Measures.vue?vue&type=script&lang=js"
export * from "./Measures.vue?vue&type=script&lang=js"
import style0 from "./Measures.vue?vue&type=style&index=0&id=7c22c314&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c22c314",
  null
  
)

export default component.exports